<template>
    <section class="client-settings--votting">
        <ChartSettings />
        <VotingSettings :votingSettings="globalVotingSettings" :votingAllowedIp="globalVotingAllowedIp"
            :isLoading="isLoading.voting" @change="changeGlobalVotingSettings"
            @saveAllowedVotingIp="saveGlobalAllowedVotingIp" />
    </section>
</template>
<script charset="utf-8">
import ChartSettings from "./Parts/ChartSettings.vue"
import VotingSettings from "./Parts/VotingSettings.vue"

import alertsHelper from "@/helpers/alerts.helper";
import settingsService from "@/services/settings.service";

export default {
    name: "ClientSettingsVoting",
    components: {
        ChartSettings,
        VotingSettings
    },
    computed: {
        globalVotingSettings() {
            return { ...this.$store.state.settings.client };
        },
        globalVotingAllowedIp() {
            return this.$store.state.settings.allowIpAddress;
        }
    },
    data() {
        return {
            isLoading: {
                voting: false
            }
        };
    },
    methods: {
        async changeGlobalVotingSettings(obj) {
            try {
                this.isLoading.voting = true;
                await settingsService.updateClientSettings(obj);
            }
            finally {
                this.isLoading.voting = false;
            }
        },

        async saveGlobalAllowedVotingIp(ip) {
            try {
                this.isLoading.voting = true;

                const response = await settingsService.setVotingAllowedIp(ip);
                if (response.status !== 200) {
                    throw await Promise.reject(response);
                }
                this.$store.state.settings.allowIpAddress = ip;
                var t = this.$swal.mixin(alertsHelper.informationSuccessElement());
                t.fire(alertsHelper.successAlert(this.$t('com.file.voting-settings.ip-save-success-info'), this.$t('com.global.success')));
            }
            finally {
                this.isLoading.voting = false;
            }
        }

    },
};
</script>
<style lang="scss" scoped>
.client-settings--votting {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    row-gap: 20px;
    column-gap: 20px;
}
</style>